export default __webpack_public_path__ + "static/media/premakumar_nj2_074.a3011d3b.pdf";